import React from 'react'
import Helmet from 'react-helmet'

import MainMenu from '@/Shared/MainMenu'
import FlashMessages from '@/Shared/FlashMessages'
import TopHeader from '@/Shared/TopHeader'
import BottomHeader from '@/Shared/BottomHeader'

export default function Layout({ title, children }) {
  return (
    <div>
      <Helmet titleTemplate="%s | OS Services" title={title} />
      <div className="flex flex-col">
        <div className="flex h-screen flex-col">
          <div className="md:flex">
            <TopHeader />
            <BottomHeader />
          </div>
          <div className="flex flex-grow overflow-hidden">
            <MainMenu className="hidden h-[calc(100vh-2rem)] w-full max-w-[16rem] overflow-y-auto !rounded-none p-2 shadow-xl shadow-blue-gray-900/5 md:block" />
            {/* To reset scroll region (https://inertiajs.com/pages#scroll-regions) add `scroll-region="true"` to div below */}
            <div className="w-full overflow-hidden overflow-y-auto px-4 py-8 md:p-12">
              <FlashMessages />
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
